import PropTypes from 'prop-types';
import { DEPRECATED_PROP_MESSAGES } from '../../constants/messages.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    /**
   * The visual style of the Link List.
   * One of: "standard", "shaded".
   * @deprecated Use a pattern of other SWAN components instead
   */ skin: deprecatedProp(PropTypes.oneOf([
        'standard',
        'shaded'
    ]), DEPRECATED_PROP_MESSAGES.pattern)
};
/**
 * @subcomponent List
 */ const LinkList = createComponent({
    displayName: 'LinkList',
    root: 'ul',
    propTypes,
    propConfig: {
        classNames (props) {
            const classNameSet = new Set([
                'swan-link-list'
            ]);
            const { skin = 'standard' } = props;
            if (skin != 'standard') classNameSet.add(`swan-link-list-skin-${skin}`);
            return classNameSet;
        }
    }
});

export { LinkList };
